<template>
  <div>


    <b-card no-body>
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row class="match-height">
          <b-col
              xl="3"
              md="4"
              sm="6"
          >
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                  <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                    <b-spinner type="grow" label="Loading..." variant="primary"/>
                  </h3>
                  <h3 v-else class="mb-25 font-weight-bolder">
                    {{c_total_registros}}
                  </h3>
                  <span>Total</span><br>
                  <b-badge variant="primary" class="mt-1 font-small-4 font-weight-bolder">
                    Total de trabajadores en lista
                  </b-badge>
                </div>
                <b-avatar
                    variant="light-primary"
                    size="45"
                >
                  <feather-icon
                      size="21"
                      icon="UsersIcon"
                  />
                </b-avatar>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col
              xl="3"
              md="4"
              sm="6"
          >
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                  <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                    <b-spinner type="grow" label="Loading..." variant="info"/>
                  </h3>
                  <h3 v-else class="mb-25 font-weight-bolder">
                    {{c_total_revertido}}
                  </h3>
                  <span>Revertidos</span><br>
                  <b-badge variant="info" class="mt-1 font-small-4 font-weight-bolder">
                    Total de trabajadores revertidos
                  </b-badge>
                </div>
                <b-avatar
                    variant="light-info"
                    size="45"
                >
                  <feather-icon
                      size="21"
                      icon="UsersIcon"
                  />
                </b-avatar>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col
              xl="3"
              md="4"
              sm="6"
          >
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                  <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                    <b-spinner type="grow" label="Loading..." variant="warning"/>
                  </h3>
                  <h3 v-else class="mb-25 font-weight-bolder">
                    {{c_total_revision}}
                  </h3>
                  <span>Para Revisión RR.HH</span><br>
                  <b-badge variant="warning" class="mt-1 font-small-4 font-weight-bolder">
                    Total de trabajadores para revisión
                  </b-badge>
                </div>
                <b-avatar
                    variant="light-warning"
                    size="45"
                >
                  <feather-icon
                      size="21"
                      icon="UserCheckIcon"
                  />
                </b-avatar>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col
              xl="3"
              md="4"
              sm="6"
          >
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center p-1">
                <div class="truncate">
                  <h3 v-if="loading2" class="mb-25 font-weight-bolder">
                    <b-spinner type="grow" label="Loading..." variant="danger"/>
                  </h3>
                  <h3 v-else  class="mb-25 font-weight-bolder">
                    {{c_total_observados}}
                  </h3>
                  <span>Observados</span><br>
                  <b-badge variant="danger" class="mt-1 font-small-4 font-weight-bolder">
                    Total de trabajadores observados
                  </b-badge>
                </div>
                <b-avatar
                    variant="light-danger"
                    size="45"
                >
                  <feather-icon
                      size="21"
                      icon="XIcon"
                  />
                </b-avatar>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>
    <b-card no-body >

      <b-card-body class="px-1 pt-1 pb-1" >

        <div >
          <b-row>
            <!-- Per Page -->
            <b-col
                xl="1"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <b-button
                  variant="gradient-primary"
                  @click="leerListaNegra('1')"
                  :disabled="loading"
                  block
                  size="sm"
              >
                <span>&emsp;</span>
                <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="RefreshCwIcon" />
              </b-button>

            </b-col>
            <b-col
                xl="2"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <b-button
                  variant="gradient-danger"
                  @click="DarDeBaja"
                  block
                  size="sm"
              >
                <span>Quitar&emsp;</span>
                <span v-if="showBaja"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="ArrowDownCircleIcon" />
              </b-button>

            </b-col>
            <b-col
                xl="4"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <b-button
                  variant="gradient-success"
                  size="sm"
                  class="mr-1"
                  @click="descargarFile"
              >
                <span v-if="loading3"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                <span v-else>
              <feather-icon
                  icon="ExternalLinkIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar Excel</span>
            </span>


              </b-button>
              <b-button
                  variant="gradient-secondary"
                  size="sm"
                  class="mr-1"
                  v-b-modal.modal-importar
              >
                <font-awesome-icon icon="fa-solid fa-file-excel"/> &nbsp;&nbsp;
                <span>
                <span class="align-middle">Importar Excel</span>
            </span>


              </b-button>
              <b-button
                  variant="gradient-secondary"
                  size="sm"
                  @click="descargarFilePlantilla"
              >

                <span v-if="loadingPlantilla"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                <span v-else>
              <feather-icon
                  icon="ExternalLinkIcon"
                  class="mr-50"
              />
              <span class="align-middle">Plantilla</span>
            </span>
              </b-button>
            </b-col>
            <b-col
                xl="2"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <v-select
                  id="grupowww"
                  v-model="fechaObservadoSelected"
                  :options="fechaObservadoFiltOpciones"
                  :reduce="fechaObservadoFiltOpciones => fechaObservadoFiltOpciones.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar fecha observación..."
                  @input="leerListaNegra('3')"
                  class="select-size-sm"

              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-col>
            <!-- Search -->
            <b-col
                xl="3"
                md="3"
                sm="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <!-- filter -->
                <b-form-group
                    label-for="filterInput"
                    class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                        id="filterInput"
                        v-model="filterTable"
                        type="search"
                        placeholder="Buscar"
                        :disabled="loading"
                        @input="filtros2"
                    />
                    <b-input-group-append>
                      <b-button
                          :disabled="!filterTable"
                          @click="filterTable = ''"
                      >
                        Borrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </b-col>

          </b-row>
        </div>

        <div>
          <vue-good-table
              @on-selected-rows-change="selectionChanged"
              :columns="columns"
              id="my-table"
              ref="my-table"
              :rows="items"
              :rtl="direction"
              :isLoading="loading"
              theme="polar-bear"
              :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: true, // disable the select info panel on top
              selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
              :pagination-options="{
              enabled: true,
              perPage:pageLength,
              //mode: 'records'
            }"
              :sort-options="{
              enabled: true,
              //initialSortBy: {field: sortByTable, type: sortAscDesc}
            }"
              styleClass="vgt-table table-format"


          >

            <template slot="table-column" slot-scope="props">

              <span v-if="props.column.field === 'dni_trabajador'">
                <div class="text-nowrap">
                   {{props.column.label}}
                </div>

              </span>

              <span v-else>
                {{props.column.label}}
             </span>
            </template>
            <template slot="table-row" slot-scope="props" >

             <span v-if="props.column.field === 'acciones'">
               <div class="text-nowrap">
                  <feather-icon
                      :id="`btn_${ props.row.dni_trabajador}_editar`"
                      icon="MinusCircleIcon"
                      style="color: #E74C3C"
                      size="16"
                      class="mx-1"
                      @click="anularRegistro( props.row.id, props.row.dni_trabajador, props.row.nombres_trabajador)"
                  />

            <b-tooltip
                title="Quitar de la lista"
                style="background-color:#E74C3C"
                :target="`btn_${ props.row.dni_trabajador}_editar`"
            />

                 <feather-icon
                     :id="`btn_${props.row.dni_trabajador}_revertir`"
                     icon="CheckCircleIcon"
                     style="color: #198754"
                     size="16"
                     class="mx-1"
                     @click="revertirRegistro(props.row.id,props.row.dni_trabajador,props.row.nombres_trabajador)"
                 />

            <b-tooltip
                title="Revertir de la lista al trabajador"
                style="background-color:#E74C3C"
                :target="`btn_${props.row.dni_trabajador}_revertir`"
            />

              </div>
            </span>
              <span v-else-if="props.column.field === 'fecha_dada_baja_format'">
              <span style="white-space: nowrap" >{{ props.row.fecha_dada_baja_format }}</span>
            </span>
              <span v-else-if="props.column.field === 'empresa'">
              <span style="white-space: nowrap" >{{ props.row.empresa }}</span>
            </span>

              <span v-else-if="props.column.field === 'estado'" class="text-body align-middle mr-25">
              <b-badge :variant="statusBajas(props.row.estado)">
                {{ salidaStatusBaja(props.row.estado)}}
              </b-badge>
            </span>

              <span v-else-if="props.column.field === 'nombres_trabajador'">
              <span style="white-space: nowrap" >{{ props.row.nombres_trabajador }}</span>
            </span>

              <span v-else-if="props.column.field === 'categoria_rango'">
              <span style="white-space: nowrap" >{{ props.row.categoria_rango }}</span>
            </span>

              <!-- Column: Common -->
              <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
            </template>

            <template slot="loadingContent">

              <div class="text-center text-dark" v-if="loading">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>


            </template>
            <div slot="emptystate" class="text-center text-dark my-1" v-if="!loading">
              No se encontraron datos con los parámetros ingresados
            </div>
            <div slot="emptystate" class="text-center text-dark my-3" v-if="loading">

            </div>

            <!-- pagination -->
            <template
                slot="pagination-bottom"
                slot-scope="props"
            >
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Mostrando 1 a
            </span>
                  <b-form-select
                      v-model="pageLength"
                      :options="['3','5','10','20','50','100','200',props.total]"
                      class="mx-1"
                      @input="(value)=>props.perPageChanged({currentPerPage:value})"
                  />
                  <span class="text-nowrap"> de {{ props.total }} registros </span>
                </div>
                <div>
                  <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="(value)=>props.pageChanged({currentPage:value})"
                  >
                    <template #prev-text>
                      <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>

        </div>
      </b-card-body>
      <b-modal
          id="modal-importar"
          ref="modal_importar"
          title="Importar Datos Masivos"
          ok-title="Importar"
          cancel-title="Cancelar"
          cancel-variant="outline-secondary"
          size="md"
          :cancel-disabled="loadingCarga"
          :ok-disabled="loadingCarga||!archivo_excel"
          centered
          no-close-on-esc
          no-close-on-backdrop
          @show=""
          @hidden=""
          @ok="importarOk"
      >
        <div v-if="loadingCarga"  align="center">
          <p>Importando datos ... </p>
          <b-spinner label="Importando ..." variant="primary"/>
        </div>
        <validation-observer v-else ref="formularioImportarTemas" #default="{invalid}">
          <b-form autocomplete="off" @submit.prevent="enviarExcelMasivos">
            <b-row>
              <b-col lg="12">
                <b-form-group
                    label="Archivo"
                    label-for="archivo"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Archivo"
                      vid="archivo"
                      rules=""
                  >
                    <b-form-file
                        id="archivo"
                        accept=".xlsx"
                        placeholder="Seleccionar Archivo Excel (.xlsx)"
                        v-model="archivo_excel"
                        ref="fileinput"
                    >
                      <template
                          slot="file-name"
                          slot-scope="{ names }"
                      >
                        <b-badge variant="primary">
                          {{ names[0] }}
                        </b-badge>
                      </template>
                    </b-form-file>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <div>



      </div>

    </b-card>




  </div>


</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { BFormCheckbox, BCardText } from 'bootstrap-vue'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { VueGoodTable } from 'vue-good-table'
import "vue-good-table/dist/vue-good-table.css";
import store from '@/store/index'
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData'

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { useToggle } from '@vueuse/core'



import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner,
  BDropdown, BDropdownItem,
  BCardHeader, BCardTitle, BCardSubTitle,
  Card,  BFormFile, BFormTextarea, BButtonGroup, BSidebar,
  VBToggle, BForm, BFormDatepicker, BLink, BInputGroupPrepend, BDropdownForm, BDropdownHeader, BDropdownDivider,
  BFormRadio, BFormRadioGroup,
  BAlert,

} from 'bootstrap-vue'
import axios from 'axios'
import qs from 'qs'
import { Modal, Button } from 'bootstrap'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VueContext from 'vue-context'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { heightFade } from '@core/directives/animations'
import alert from '@/views/components/alert/Alert'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
    BFormCheckbox,
    BCardText,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    VueApexCharts,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    apexchart: VueApexCharts,
    Modal,
    ValidationProvider,
    ValidationObserver,
    VueContext,
    BLink,
    BFormFile,
    BFormTextarea,
    BButtonGroup,
    BSidebar,
    BFormDatepicker,
    BInputGroupPrepend,
    BForm,
    BDropdownForm,
    BDropdownHeader,
    BDropdownDivider,
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    useToggle
  },
  directives: {
    'b-modal': VBModal,
    'modal': Modal,
    'height-fade': heightFade,
    Ripple,
  },
  data() {
    return {

      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: false,
      sortByTable: "nombres_trabajador",
      sortAscDesc:"asc",
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      perPage_c: 10,
      pageOptions_c: [5, 10, 15],
      totalRowsTareos: 1,
      currentPage_c: 1,
      sortBy_c: '',
      sortDesc_c: false,
      sortDirection_c: 'asc',
      filter_tareo: null,
      filterOnTareos: [],
      loading_c: false,
      estadoModal: false,
      estadoGrafico:false,
      showBaja:false,
      infoModal: {
        title: '',
        boton: '',
        titleEstadistica:'',
        titleAsistencia:'',
        titleasistenciaRangoText:'',
        titleasistenciaRangoTextGlobal:'',
      },
      loading: false,


      fechaObservadoSelected : null,
      fechaObservadoOpciones: [],
      fechaObservadoFiltOpciones:[],

      pageLength: 10,
      dir: false,
      columns: [

        {
          field: 'acciones',
          label: 'ACCIONES',
        },
        {
          label: 'FECHA OBSERVACIÓN',
          field: 'fecha_dada_baja_format',
          sortable: true,
        },
        {
          label: 'ESTADO',
          field: 'estado',
          //sortable: false,
        },
        {
          label: 'EMPRESA',
          field: 'empresa',
          //sortable: false,
          tdClass: 'text-left',
        },
        {
          label: 'DNI TRABJADOR',
          field: 'dni_trabajador',
          //sortable: false,

        },
        {
          label: 'TRABAJADOR',
          field: 'nombres_trabajador',
          //sortable: false,
          type: 'text',
        },
        {
          label: 'INICIO CAMPAÑA',
          field: 'fecha_start_campaing',
          //sortable: false,
        },
        {
          label: 'FIN CAMPAÑA',
          field: 'fecha_end_campaing',
          //sortable: false,
        },
        {
          label: 'FECHA CORTE TAREO',
          field: 'fecha_corte_tareo',
          //sortable: false,
        },
        {
          label: 'FECHA RANGO INICIAL',
          field: 'fecha_rango_inicial',
          //sortable: false,
        },
        {
          label: 'FECHA RANGO FINAL',
          field: 'fecha_rango_final',
          //sortable: false,
        },
        {
          label: 'PROMEDIO  RANGO',
          field: 'promedio_cumplimiento_cuadrilla_rango',
          //sortable: true,
        },
        {
          label: 'CATEGORÍA RANGO',
          field: 'categoria_rango',
          //sortable: true,
        },
        {
          label: 'MÍNIMO RANGO',
          field: 'valor_minimo_rango',
          //sortable: false,
        },
        {
          label: 'MÁXIMO RANGO',
          field: 'valor_maximo_rango',
          //sortable: false,
        },
        {
          label: 'DESVIACIÓN ESTÁNDAR RANGO',
          field: 'valor_desviacion_estandar_muestral_rango',
          //sortable: true
        },
        {
          label: 'CONDICIÓN RANGO',
          field: 'valor_condicion_rango',
          //sortable: true
        },
        {
          label: 'RESULTADO CONDICIÓN',
          field: 'resultado_condicion_rango',
          //sortable: true
        },
        {
          label: 'TOTAL TAREO HISTORICO',
          field: 'total_dia_tareo_historico_corte',
          //sortable: true
        },
        {
          label: 'DÍAS LABORES HISTORICO',
          field: 'total_dia_tareo_historico_otra_labores_corte',
          //sortable: true
        },
        {
          label: 'DÍAS COSECHA HISTORICO',
          field: 'total_dia_tareo_historico_cosecha_corte',
          //sortable: true
        },
        {
          label: 'DÍAS FALTA HISTORICO',
          field: 'total_dia_falta_historico_corte',
          //sortable: true
        },


      ],
      rowsBajaProductividad: [],
      items: [],
      items2: [],
      show: false,
      status: [
        {
          1: 'PARA REVISIÓN RRHH',
          2: 'OBSERVADO',
          3: 'REVERTIDO',
        },
        {
          1: 'light-warning',
          2: 'light-danger',
          3: 'light-info',
        }
      ],
      c_total_registros:0,
      c_total_observados:0,
      c_total_revision:0,
      c_total_revertido:0,
      loading2: false,
      loading3: false,
      loadingPlantilla: false,

      shift: '',
      rowSelection: [],
      filterDropdown:[],

      contadorRoot:0,
      root:null,

      rowsBajaProductividadFiltro: [],
      loadingCarga: false,
      archivo_excel: null,


      filterTable: null,

      isThema:true,
      isThemaPage_dia:"table-format tablita",
      isThemaPage_noche:"table-format-noche tablita",

    }
  },
  props: ['sometext'],
  computed: {

    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },

    salidaStatusBaja() {
      const salidaStatusBaja = {
        /* eslint-disable key-spacing */
        1: 'PARA REVISIÓN RRHH',
        2: 'OBSERVADO',
        3: 'REVERTIDO',
        /* eslint-enable key-spacing */
      }

      return status => salidaStatusBaja[status]
    },
    statusBajas() {
      const statusColorBaja = {
        /* eslint-disable key-spacing */
        1: 'light-warning',
        2: 'light-danger',
        3: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColorBaja[status]
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    statusCosecha() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: 'light-success',
        2: 'light-warning',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    salidaCosecha() {
      const salidaCosecha = {
        /* eslint-disable key-spacing */
        1: 'NUEVO',
        2: 'ANTIGUO',
        3: 'Sin contrato',
        /* eslint-enable key-spacing */
      }

      return status => salidaCosecha[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },

  },
  mounted() {

    this.leerListaNegra('2');

  },
  methods: {

    leerListaNegra(tipo){
      var yo = this

      yo.loading = true
      //if(tipo !='3'){
      yo.loading2 = true

      // }



      let fecha_observacion = yo.fechaObservadoSelected;
      console.log( yo.fechaObservadoSelected);

      if(fecha_observacion == null || yo.fechaObservadoSelected == "T"){
        fecha_observacion = 'T';
      }else if (fecha_observacion !='T') {
        var arrayDeCadenas = fecha_observacion.split('T');
        var arrfecha = arrayDeCadenas[0].split('-');
        var arrHora = arrayDeCadenas[1].split('Z');
        var arrHora_sep = arrHora[0].split('.');
        var hora_selected = arrHora[0];
        if (arrHora_sep.length>1){
          hora_selected = arrHora_sep[0];
        }
        fecha_observacion = arrfecha[2]+"/"+arrfecha[1]+"/"+arrfecha[0] +" "+hora_selected;
      }

      yo.items = [];
      var config = {
        method: 'get',
        url: '/cosecha/cosecha/listaNegra/listaAll/?fecha_observacion='+fecha_observacion+"&area_gestion=RRHH",
        headers: { }
      };


      axiosIns(config)
          .then((response) => {
            yo.items = response.data.response;
            console.log("Data: ");
            console.log(yo.items);
            yo.items2 =  yo.items;
            yo.totalRows = yo.items.length
            yo.c_total_d = yo.totalRows - 3;


            if(tipo == '2'){
              yo.fechaObservadoOpciones = [];
              yo.fechaObservadoFiltOpciones = [];

              for (let value of yo.items){
                if (value.fecha_dada_baja_date != null && value.fecha_dada_baja_date !== '' && value.fecha_dada_baja_date !== ' ' && value.fecha_dada_baja_date !== '  ')
                {
                  //yo.fechaObservadoOpciones.push(value.fecha_dada_baja)
                  yo.fechaObservadoFiltOpciones.push({value: value.fecha_dada_baja_date, text:value.fecha_dada_baja_format});
                }
              }
              let setObs   = new Set( yo.fechaObservadoFiltOpciones.map( JSON.stringify ) );
              yo.fechaObservadoFiltOpciones = Array.from(setObs).map(JSON.parse);
              yo.fechaObservadoFiltOpciones.sort(function(x, y) {
                var firstDate = new Date(x.value),
                    SecondDate = new Date(y.value);

                if (firstDate > SecondDate) return -1;//if (firstDate < SecondDate) return -1;
                if (firstDate < SecondDate) return 1;//if (firstDate > SecondDate) return 1;

                return 0;
              });
              yo.fechaObservadoFiltOpciones.unshift({value: 'T', text:"TODAS LA FECHAS OBS."});
              yo.fechaObservadoSelected = "T";
            }

            if(tipo =='1' || tipo == '2'){

              this.resumenListaNegra(fecha_observacion);
            }

          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading = false
        yo.loading2 = false

      });

    },
    descargarFile() {
      const yo = this
      const spd = yo.items

      if (spd.length > 0){
        const data = JSON.stringify(
            {
              "datas":spd,
            }
        )


        const config = {
          method: 'post',
          url: '/cosecha/cosecha/exportar/listaObservados/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        }

        axiosIns(config)
            .then(function (response) {
              console.log(response);
              if (response.status === 200) {

                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Reporte de observados RRHH.xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();



                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }


            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loading_exp = false
            });

      }else{
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },
    resumenListaNegra(fecha_observacion){
      var yo = this

      var config = {
        method: 'get',
        url: '/cosecha/cosecha/listaNegra/contarestados/?fecha_observacion='+fecha_observacion+"&area_gestion=RRHH",
        headers: { }
      };

      axiosIns(config)
          .then((response) => {
            var items = response.data.response;
            yo.c_total_registros = items[0]["cantidad_total"];
            yo.c_total_observados = items[0]["cantidad_observado"];
            yo.c_total_revision = items[0]["cantidad_en_revision"];
            yo.c_total_revertido = items[0]["cantidad_revertido"];

          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){

      });

    },
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    anularRegistro(id,dni,nombres){

      var yo = this
      var icon = "warning"
      var mensaje = " quitar de la lista negra";
      var valorUpdate = "0";

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres "+mensaje+" al trabajador " + nombres + "?",
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.$nextTick(() => {

            var yo = this

            var qs = require('qs');
            var data = qs.stringify({
              'estado_dar_baja': '0',
              'dni_trabajador': dni,
            });


            var config = {
              method: 'post',
              url: '/cosecha/cosecha/trabajadorNuevo/anular/',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              data : data
            };

            axiosIns(config)
                .then(function (response) {
                  var res = response.data.respuesta;
                  yo.eliminarRegistro(id);


                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                });

            this.estadoModal = false
          })

        }
      })
    },
    revertirRegistro(id,dni,nombres){

      var yo = this
      var icon = "warning"
      var mensaje = " revertir de la lista negra";
      var valorUpdate = "0";

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres "+mensaje+" al trabajador " + nombres + "?",
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.$nextTick(() => {

            var yo = this

            var qs = require('qs');
            var data = qs.stringify({
              'estado_dar_baja': '0',
              'estado_proceso_observados': '3',
              'dni_trabajador': dni,
            });


            var config = {
              method: 'post',
              url: '/cosecha/cosecha/trabajadorNuevo/revertir/',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              data : data
            };

            axiosIns(config)
                .then(function (response) {
                  console.log(response);
                  yo.leerListaNegra('1');

                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                });

            this.estadoModal = false
          })

        }
      })
    },
    eliminarRegistro(id){
      var yo = this

      var config = {
        method: 'delete',
        url: '/cosecha/cosecha/listaNegra/eliminar/' + id,
        headers: { }
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 204){
              yo.leerListaNegra('1');
              yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'El trabajador ha sido eliminado correctamente', 'success')
            }else{
              yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
            }
          })
          .catch(function (error) {
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
          });
    },
    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },
    selectionChanged() {
      this.rowSelection = []
      const filasSeleccionadas = this.$refs['my-table'].selectedRows
      var table = document.getElementById("my-table").getElementsByTagName("tr");
      filasSeleccionadas.forEach((value, index) => {
        this.rowSelection.push(filasSeleccionadas[index]['dni_trabajador'])
      })

    },
    DarDeBaja() {
      var yo = this
      var selecionado = yo.rowSelection.length


      var listaTrabajadoresConcatenado = "";

      for (var i = 0;i<yo.rowSelection.length; i++ ){

        listaTrabajadoresConcatenado = listaTrabajadoresConcatenado + "'"+yo.rowSelection[i].toString()+"'";

      }
      var listaTrabajadoreBaja = listaTrabajadoresConcatenado.replaceAll("''", "','");




      var icon = 'warning'
      var mensaje = ' quitar de la lista '
      var trab = ' trabajadores'
      var valorUpdate = '0'
      var mensajeSalida = 'Trabajador dado de baja'

      var fecha_observacion = yo.fechaObservadoSelected;

      if(fecha_observacion == null || fecha_observacion == 'T'){

        yo.$swal.fire(
            'Mensaje',
            'debe seleccionar una fecha de observación',
            'warning'
        )
            .then((result) => {
            })
        return
      }



      if (selecionado == 0) {
        yo.$swal.fire(
            'Mensaje',
            'debe seleccionar trabajador',
            'warning'
        )
            .then((result) => {
            })
        return

      } else if (selecionado == 1) {
        trab = ' trabajador'
      }


      this.$swal({
        title: '¡Alerta!',
        text: '¿Seguro que quieres ' + mensaje + ' a ' + selecionado + trab + ' con fecha observación el ' +fecha_observacion+ '?',
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {

              this.$nextTick(() => {

                var yo = this

                yo.showBaja = true
                this.$swal.fire({
                  title: 'Generando...',
                  text: 'Por favor espere, se está quitando los trabajador(es) seleccionados',
                  footer: 'No cierre la ventana',
                  imageUrl: require('@/assets/images/loading/loading.gif'),
                  imageWidth: 200,
                  imageHeight: 200,
                  showCancelButton: false, // There won't be any cancel button
                  showConfirmButton: false // There won't be any confirm button
                })

                let fecha_observacion = yo.fechaObservadoSelected;
                if(fecha_observacion != null && fecha_observacion != "T"){
                  var arrayDeCadenas = fecha_observacion.split('T');
                  var arrfecha = arrayDeCadenas[0].split('-');
                  var arrHora = arrayDeCadenas[1].split('Z');
                  var arrHora_sep = arrHora[0].split('.');
                  var hora_selected = arrHora[0];
                  if (arrHora_sep.length>1){
                    hora_selected = arrHora_sep[0];
                  }
                  fecha_observacion = arrfecha[2]+"/"+arrfecha[1]+"/"+arrfecha[0] +" "+hora_selected;
                }

                var qs = require('qs')
                var data = qs.stringify({
                  'dni_trabajador': listaTrabajadoreBaja.toString(),
                  'fecha_observacion':fecha_observacion,
                })


                var config = {
                  method: 'post',
                  url: '/cosecha/cosecha/listaObservado/quitar/all/',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  data: data
                }

                axiosIns(config)
                    .then(function (response) {
                      var res = response.data.respuesta;
                      if(res == "Exitoso"){
                        yo.$swal.fire(
                            'Dado de baja!',
                            'Trabajador eliminado de la lista de observados',
                            'success'
                        )
                            .then((result) => {
                              yo.leerListaNegra('1');
                            });
                      }
                    })
                    .catch(function (error) {
                      console.log(error)
                      yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                    }).finally(function (){
                  yo.showBaja = false

                });

              })

            }
          })

    },
    filtros2(){
      var palabra = this.filterTable !== null ? this.filterTable.toLowerCase() : ''
      this.items = this.items2
      this.items = this.items.filter(
          invoice =>
              (invoice.dni_trabajador.toLowerCase().includes(palabra) || invoice.nombres_trabajador.toLowerCase().includes(palabra)))
      this.totalRows = this.rowsBajaProductividadFiltro.length
    },
    enviarExcelMasivos(){
      const yo = this

      this.$refs.formularioImportarTemas.validate().then(success => {
        if (success) {
          yo.loadingCarga = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('area_gestion', "RRHH")

          console.log(data);

          const config = {
            method: 'post',
            url: '/cosecha/cosecha/importExcelObservados/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data : data
          };

          axiosIns(config)
              .then(function (response) {
                console.log(response.data);
                if(response.status === 200){
                  // yo.traerDeserciones()
                  let total_registro =response.data['row'];
                  if(!response.data['is_error']){
                    yo.mostrarNotificacion('¡Registro Guardado!', 'CheckIcon', 'Se realizaron la creación de '+ total_registro +' Observados.', 'success', 5000)
                    yo.leerListaNegra('2');
                  }else{
                    yo.mostrarNotificacion('Error en el registro', 'BellIcon', 'Hubo un error en el registro, intentelo nuevamente en unos minutos.\n '+response.data['message'].toString(), 'danger', 5000)

                  }


                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', 'Hubo un error en el registro, intentelo nuevamente en unos minutos.\n '+error.toString(), 'danger', 5000)
              })
              .finally(function () {
                yo.archivo_excel = null
                yo.loadingCarga = false
                yo.$nextTick(() => {
                  yo.$refs['modal_importar'].toggle('#toggle-btn')
                })
              })
          ;
        }
      })
    },
    descargarFilePlantilla(){
      var yo = this
      this.loadingPlantilla = true
      var config = {
        method: 'post',
        url: '/cosecha/cosecha/observados/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_Observados.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingPlantilla = false
          });
    },
    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarExcelMasivos()
    },

  },
}
</script>

<style lang="scss">

@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';

.tablita{
  min-height: 58vh!important;
  display:inline-block;
  position: relative;

}
.table-format {
  border: 2px solid #ebe9f1;
  border-collapse: collapse;
  cursor:pointer; cursor: hand;
}

.table-format th{
  border-bottom: solid 1px #ebe9f1;
  padding: 15px;
  text-align: left;
  //  background-color: rgba(243, 242, 247, 1);
  border-bottom: solid 2px #ebe9f1;
}

.table-format th:nth-child(1){
  border-bottom: solid 1px #ebe9f1;
  // position: fixed;
  // border-bottom: solid 1px #ebe9f1;
}

.table-format td{
  font-family: Montserrat,Arial, Helvetica, SansSerif;
  padding: 15px;
  caption-side: bottom;
  text-align: left;
  border-bottom: solid 1px #ebe9f1;
}


.table-format tbody tr:hover {
  background-color:rgba(246, 246, 249, 1);
  font-weight: bold;


}




.dropdown-toggle::after {
  background-image: none;
}



</style>
<style scoped>
.hello {
  width: 100%;
  height: 300px;
}
</style>

